import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import Masonry from 'react-masonry-component';
import Footer from '../../../components/Footer/index';
import Banner from '../../../components/Banner/index';
import PRODUCTIONS_PAGINATION_QUERY from '../../../graphql/ProductionsPagination';
import SearchBar from '../../../components/SearchBar/index';
import IsGuest from '../../../utils/IsGuest';
import { ProductionCard } from '../../../components/Cards';
import Pagination from '../../../components/Pagination';

class ProductionsPage extends Component {
  onSearch(terms) {
    if (!{}.hasOwnProperty.call(terms, 'advanced') || terms.advanced === false) {
      this.props.history.push(`/search/${terms.query}`);
    } else {
      let path = '/search/elements';
      if (terms.kind === 'productions') {
        path = '/search/productions';
      }
      this.props.history.push({
        pathname: path,
        state: terms,
      });
    }
  }

  render() {
    const childElements = (this.props.productions || []).map(production => (
      <ProductionCard
        key={production.id}
        hideInfo={IsGuest()}
        production={production}
      />
    ));

    return (
      <div>
        <Helmet>
          <title>Producciones - Escena Marketplace</title>
        </Helmet>
        <Banner />
        <div className="recent-properties">
          <div className="container">
            <div className="main-title">
              <h1>Producciones</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row mb-40">
              <SearchBar onSearch={terms => this.onSearch(terms)} />
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12">
                <Masonry
                  className="my-gallery-class" // default ''
                  options={{
                    transitionDuration: 0,
                  }}
                >
                  {childElements}
                </Masonry>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Pagination url="/productions" pages={this.props.pages} currentPage={this.props.current} />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withTheaters = graphql(PRODUCTIONS_PAGINATION_QUERY, {
  props: ({ data }) => {
    const pagination = data.productionPagination || {};
    return {
      loading: data.loading,
      productions: pagination.productions || [],
      total: pagination.count || 0,
      pages: pagination.pages || 1,
      current: pagination.currentPage || 1,
    };
  },
  options: ({ match }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      page: Number.parseInt(match.params.page, 10) || 1,
    },
  }),
});

export default withTheaters(ProductionsPage);



// WEBPACK FOOTER //
// ./src/containers/General/ProductionsPage/index.js